import { render, staticRenderFns } from "./workComadd.vue?vue&type=template&id=a30dffb2&scoped=true&"
import script from "./workComadd.vue?vue&type=script&lang=js&"
export * from "./workComadd.vue?vue&type=script&lang=js&"
import style0 from "./workComadd.vue?vue&type=style&index=0&id=a30dffb2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30dffb2",
  null
  
)

export default component.exports